import React, { useEffect } from "react";

import AuthLayout from "components/layout/AuthLayout";
import LoginForm from "features/auth/LoginForm";

export default function Login() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <AuthLayout title="Welcome back" subtitle="Log in to continue learning.">
      <LoginForm />
    </AuthLayout>
  );
}
